const RESPONSE_GRID_ADMIN_EMAILS = new Set([
  'steveb@responsegrid.com',
  'steveb@responsegrid.net',
  'noahd@responsegrid.com',
  'noahd@responsegrid.net',
  'jerrys@responsegrid.com',
  'jerrys@responsegrid.net',
  'cameront@responsegrid.com',
  'cameront@responsegrid.net',
  'adams@responsegrid.com',
  'adams@responsegrid.net'
])

export function isResponseGridAdmin (email) {
  if (!email) return false
  return RESPONSE_GRID_ADMIN_EMAILS.has(email.toLowerCase())
}
